// @ts-check
import React, { Component } from 'react';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import { Page, Row } from 'shared/containers/portal_layout';

import Demographics from './Demographics';
import Financials from './Financials';
import Coverages from './Coverages';
import PrimaryInsurance from './PrimaryInsurance';
import styles from './Show.module.scss';

class Show extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { fetched: false };
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    api
      .get(`${this.props.route.apiEndpoint}/insurance_coverages/${this.props.params.id}`)
      .then(response => {
        this.setState({ fetched: true, ...response.data });
      });
  }

  refresh() {
    this.setState({ fetched: false });
    api
      .post(`${this.props.route.apiEndpoint}/insurance_coverages/${this.props.params.id}/refresh`)
      .then(response => {
        this.setState({ fetched: true, ...response.data });
      });
  }

  render() {
    return (
      <Page title="Eligibility">
        {this.state.fetched ? (
          <PresentationComponent {...this.state} refresh={this.refresh} />
        ) : (
          <Row>
            <LoadingContent />
          </Row>
        )}
      </Page>
    );
  }
}

export default Show;

const NotCheckable = () => (
  <p className={styles.message}>
    Sorry, we are not able to obtain insurance details for that carrier.
  </p>
);

const NotCompleted = () => (
  <p className={styles.message}>
    We are still gathering details. Please refresh this page in a few minutes.
  </p>
);

const EmptyResponse = () => (
  <p className={styles.message}>
    Sorry, no details are available for the provided insurance information.
  </p>
);

const PresentationComponent = ({
  eligibilityCompleted,
  checkable,
  raw,
  demographics,
  financials,
  coverages,
  primaryInsurance,
  primaryInsuranceDetails,
  calculated,
  refresh,
  back,
}) => {
  if (!checkable) return <NotCheckable />;
  if (!eligibilityCompleted) return <NotCompleted />;
  if (raw === null) return <EmptyResponse />;
  return (
    <div>
      {refresh && (
        <button className="btn btn-primary" onClick={refresh}>
          Refresh
        </button>
      )}
      {back && (
        <button className="btn btn-primary" onClick={back}>
          Back
        </button>
      )}
      <Row>
        <span className="span4">
          <Row>
            <Demographics demographics={demographics} calculated={calculated} />
          </Row>
          <Row>
            <PrimaryInsurance
              primaryInsurance={primaryInsurance}
              primaryInsuranceDetails={primaryInsuranceDetails}
            />
          </Row>
        </span>
        <span className="span8">
          <Row>
            <Coverages coverages={coverages} />
          </Row>
        </span>
      </Row>
      <Row>
        <Financials financials={financials} />
      </Row>
      <Row>
        <pre>{JSON.stringify(raw, null, ' ')}</pre>
      </Row>
    </div>
  );
};

export { PresentationComponent };
